import { UpdateImageTypeComponent } from './update-image-type/update-image-type.component'
import { CreateImageTypeComponent } from './create-image-type/create-image-type.component'
import { ImageTypesComponent } from './image-types.component'
import { MainLayoutComponent } from '@components/main-layout/main-layout.component'
import { Routes } from '@angular/router'
import { AuthGuard } from 'src/app/guards/auth.guard'
import { NgxPermissionsGuard } from 'ngx-permissions'

export const imageTypesRoutes: Routes = [
  {
    path: 'admin/image-types',
    component: MainLayoutComponent,
    canActivate: [AuthGuard, NgxPermissionsGuard],
    data: {
      permissions: {
        only: 'SYSTEM_CONFIGURATION_PANEL',
        redirectTo: '/',
      },
    },
    children: [
      {
        path: '',
        component: ImageTypesComponent,
        data: {
          permissions: {
            only: 'SYSTEM_CONFIGURATION_PANEL',
            redirectTo: '/',
          },
        },
      },
      {
        path: 'create',
        component: CreateImageTypeComponent,
        data: {
          permissions: {
            only: 'SYSTEM_CONFIGURATION_PANEL',
            redirectTo: '/',
          },
        },
      },
      {
        path: ':id/update',
        component: UpdateImageTypeComponent,
        data: {
          permissions: {
            only: 'SYSTEM_CONFIGURATION_PANEL',
            redirectTo: '/',
          },
        },
      },
    ],
  },
]
